
import Vue from 'vue'

/**
 * This is the new WizardSteps for onboarding.
 * Because all the wizards in the app are generally getting shorter,
 * it no longer to handles navigation and the changing next/previous/finalize buttons,
 * instead handing it to steps themselves.
 *
 */

export default Vue.extend({
  name: 'WizardWrapper',
  props: {
    stepTitle: {
      type: String,
      required: true,
    },
    stepSubtitle: {
      type: String,
    },
    stepsTotal: {
      type: Number,
      required: true,
    },
    stepNumber: {
      type: Number,
      required: true,
    },
  },
  computed: {
    progress(): string {
      return `${this.stepNumber}/${this.stepsTotal}`
    },
  },
})
